module.exports = __webpack_public_path__ + "static/media/javascript_logo.c4cea1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/javascript_logo.png
// module id = 409
// module chunks = 1